import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Container = styled(Box)``

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xLarge}px;

  .header-item {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;

    .header-item-text {
      color: ${theme.colors.foreground};
      text-align: center;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
      white-space: nowrap;

      span {
        text-transform: capitalize;
      }
    }
  }
`

export const ChartWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 17px;
  max-width: 1686px;
  margin-left: auto;
  margin-right: auto;

  .chart-container {
    width: 100%;
    height: 360px;
    max-width: 1724px;

    .trends-d3-wrapper {
      position: relative;
      width: 100%;
      height: 100%;

      .svg-d3 {
        background: ${theme.colors.legacySurfaceItemBackgroundLow};
      }

      .data-point-tooltip {
        display: none;
        position: absolute;
        opacity: 1;
        border-radius: ${theme.attributes.borderRadius.small};
        background: ${theme.colors.frameworkCardBg};
        z-index: 10000;

        &:before {
          content: '';
          width: 12px;
          height: 12px;
          transform: rotate(45deg);
          background-color: ${theme.colors.frameworkCardBg};
          position: absolute;
          left: 46%;
          top: 50px;
        }

        .tooltip-wrapper {
          padding: ${theme.spacing.xSmall}px;
          gap: ${theme.spacing.half}px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;

          p {
            margin: 0;
            color: ${theme.colors.foreground};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.large};
            font-style: normal;
            line-height: normal;
            white-space: nowrap;
          }

          .tooltip-title {
            font-weight: ${theme.typography.fontWeight.thick};
          }

          .tooltip-text {
            font-weight: ${theme.typography.fontWeight.normal};
          }
        }

        .prediction-text-wrapper {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 232px;
          gap: ${theme.spacing.xSmall}px;
          margin-top: -${theme.spacing.half}px;

          .tooltip-performance {
            color: ${theme.colors.foreground};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.xLarge};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.bold};
            line-height: 24px;
            letter-spacing: 0.1px;
          }

          svg {
            margin-left: -${theme.spacing.xsm}px;
          }
        }

        .tooltip-units-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 232px;

          .tooltip-units-prediction {
            color: ${theme.colors.foreground};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.large};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.normal};
            line-height: 20px;
            letter-spacing: 0.25px;
            margin-top: 0;
            margin-bottom: 0;
          }
        }

        .tooltip-performance,
        .tooltip-units {
          color: ${theme.colors.foreground};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: 20px;
          letter-spacing: 0.25px;
        }

        .tooltip-performance {
          margin: ${theme.spacing.xSmall}px 0;

          &.prediction-date {
            color: ${theme.colors.foreground};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.xLarge};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.bold};
            line-height: 24px;
            letter-spacing: 0.1px;
            margin-top: 2px;
          }
        }

        .tooltip-units {
          margin: 0;
        }

        .severity-text {
          text-transform: capitalize;
        }
      }
    }
  }

  .chart-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0);
    background: ${theme.colors.analyzerScrollbarTrack};
  }

  .chart-container::-webkit-scrollbar-thumb {
    height: 5px;
    background-color: ${theme.colors.analyzerScrollbarThumb};
  }

  .chart-container::-webkit-scrollbar-thumb:hover {
    background-color: ${theme.colors.analyzerScrollbarThumb};
  }

  .chart-container::-webkit-scrollbar:vertical {
    display: none;
  }
`
